import { Grid, Typography, Card, CardContent, Box } from "@material-ui/core";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MaskAndValid from "utils/maskAndValid";

const formatSimNao = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "S" : "N";
  const str = value.toString().toUpperCase();
  if (str === "S" || str === "SIM" || str === "TRUE" || str === "1") return "S";
  if (
    str === "N" ||
    str === "NÃO" ||
    str === "NAO" ||
    str === "FALSE" ||
    str === "0"
  )
    return "N";
  return str;
};

const formatModelo = (value) => {
  if (!value) return "-";
  const modelos = {
    1: "1 - Normal",
    2: "2 - Cod. Barras Padrão",
    3: "3 - DUN 14",
    4: "4 - Especial",
  };
  return modelos[value] || value.toString();
};

const formatDiasSemana = (value) => {
  if (!value) return "-";
  if (typeof value === "string") {
    const dias = {
      SEG: "SEG",
      TER: "TER",
      QUA: "QUA",
      QUI: "QUI",
      SEX: "SEX",
      SAB: "SÁB",
      DOM: "DOM",
    };
    return value
      .split(" ")
      .map((d) => dias[d.toUpperCase()] || d)
      .join(" ");
  }
  return value.toString();
};

const formatPercentual = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return `${value.toString()}%`;
};

export default function InvoicingRulesDisplay({ invoicingRules }) {
  // if (!invoicingRules) {
  //   return (
  //     <Card>
  //       <CardContent>
  //         <Typography variant="body2">Dados não localizados</Typography>
  //       </CardContent>
  //     </Card>
  //   );
  // }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" marginBottom={2}>
              <LocalShippingIcon
                style={{
                  color: "#1976d2",
                  marginRight: "8px",
                  fontSize: "28px",
                }}
              />
              <Typography variant="h4" style={{ color: "#1976d2" }}>
                Regra de Expedição
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  Modelo: {formatModelo(invoicingRules?.Modelo)}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  Enviar rolos entre:{" "}
                  {invoicingRules?.EnviarRolosEntreInicio || "-"} Até{" "}
                  {invoicingRules?.EnviarRolosEntreFim || "-"} Mts.
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Enviar paletizado:{" "}
                  {formatSimNao(invoicingRules?.EnviarPaletizado)} (S/N)
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Utilizar fita personalizadas da Karsten:{" "}
                  {formatSimNao(invoicingRules?.UtilizarFitaPersonalizada)}{" "}
                  (S/N)
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  Grade de encaixotamento:{" "}
                  {invoicingRules?.GradeEncaixotamento?.toString() || "-"}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" marginBottom={2}>
              <ReceiptIcon
                style={{
                  color: "#1976d2",
                  marginRight: "8px",
                  fontSize: "28px",
                }}
              />
              <Typography variant="h4" style={{ color: "#1976d2" }}>
                Regra de Faturamento
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  % de Bonificação:{" "}
                  {formatPercentual(invoicingRules?.PercentualBonificacao)}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Data Início p/ entrega:{" "}
                  {invoicingRules?.DataInicioEntrega
                    ? MaskAndValid.formattDateBR(
                        invoicingRules.DataInicioEntrega
                      )
                    : "-"}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Data Início p/ faturamento:{" "}
                  {invoicingRules?.DataInicioFaturamento
                    ? MaskAndValid.formattDateBR(
                        invoicingRules.DataInicioFaturamento
                      )
                    : "-"}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Não faturar: {formatDiasSemana(invoicingRules?.NaoFaturar)}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Cliente não recebe:{" "}
                  {formatDiasSemana(invoicingRules?.ClienteNaoRecebe)}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  Data Início p/ faturamento Original:{" "}
                  {invoicingRules?.DataInicioFaturamentoOriginal
                    ? MaskAndValid.formattDateBR(
                        invoicingRules.DataInicioFaturamentoOriginal
                      )
                    : "-"}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                      Aceita faturar até:{" "}
                      {invoicingRules?.AceitaFaturarAte?.toString() || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                      Ou Faturar: {invoicingRules?.OuFaturar?.toString() || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                      Reais em: {invoicingRules?.ReaisEm?.toString() || "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                      Reais a cada:{" "}
                      {invoicingRules?.ReaisACada?.toString() || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  Enviar paletizado:{" "}
                  {formatSimNao(invoicingRules?.EnviarPaletizadoFaturamento)}{" "}
                  (S/N)
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Notas fiscais por dia:{" "}
                  {invoicingRules?.NotasFiscaisPorDia?.toString() || "-"}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Dia(s): {invoicingRules?.DiasNotasFiscais?.toString() || "-"}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" marginBottom={2}>
              <AttachMoneyIcon
                style={{
                  color: "#1976d2",
                  marginRight: "8px",
                  fontSize: "28px",
                }}
              />
              <Typography variant="h4" style={{ color: "#1976d2" }}>
                Regra de Financeira
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  % Desconto na Duplicata:{" "}
                  {formatPercentual(
                    invoicingRules?.PercentualDescontoDuplicata
                  )}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Vencimento no início da entrega:{" "}
                  {formatSimNao(invoicingRules?.VencimentoInicioEntrega)} (S/N)
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Vencimento nos dias:{" "}
                  {invoicingRules?.VencimentoNosDias?.toString() || "-"} Ou{" "}
                  {invoicingRules?.VencimentoNosDiasOu?.toString() || "-"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  Contar vencto a partir mês subsequente a entrega:{" "}
                  {formatSimNao(invoicingRules?.ContarVencimentoMesSubsequente)}{" "}
                  (S/N)
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Vencimento na semana:{" "}
                  {formatDiasSemana(invoicingRules?.VencimentoNaSemana)}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  Fora mês: {formatSimNao(invoicingRules?.ForaMes)} (S/N)
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  % Bonif. mercadoria:{" "}
                  {formatPercentual(
                    invoicingRules?.PercentualBonificacaoMercadoria
                  )}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  % Verba Contrato:{" "}
                  {formatPercentual(invoicingRules?.PercentualVerbaContrato)}
                </Typography>
                <Typography variant="h5" style={{ marginTop: "0.5rem" }}>
                  % Verba extra:{" "}
                  {formatPercentual(invoicingRules?.PercentualVerbaExtra)}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
